var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big-title-box"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"line"}),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_c('p',{staticClass:"more"},[_vm._v("更多>>")])])}
var staticRenderFns = []

export { render, staticRenderFns }